import { getClientState, setCurrentMove } from './state';
import { apolloStore } from '../../app/apollo-client-instance';
import { remote } from '../operations';
import { reduxStore } from '../../common/redux';

export const maybeSetMoveIqMove = () =>
  getClientState().then(({ currentMove, moveIqMove }) => {
    const { moveIqMoveId } = currentMove;
    const { homeSize } = currentMove.homeSize
      ? currentMove
      : reduxStore().getState();

    return !moveIqMoveId
      ? apolloStore()
          .mutate(remote.setMoveIqMove({ ...moveIqMove, homeSize }))
          .then(({ data: { setMoveIqMove: { move } } }) =>
            setCurrentMove(apolloStore(), { moveIqMoveId: move.id })
          )
      : Promise.resolve();
  });
